<span
  [matTooltip]="tooltip"
  [matTooltipPosition]="tooltipPosition"
  class="icon-badge"
  >{{ count }}</span
>
